import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { db } from "astrid-firebase";
import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";

import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";
import OpenButton from "../../../ui/components/OpenButton/OpenButton";

import AddContractorForm from "../../../organizations/views/OrganizationSettingsView/components/AddContractorForm";
import Table from "../../../tables/components/Table";

import useContractorsDropdownMenuOptions from "./hooks/useContractorsDropdownMenuOptions";
import useContractorsTableColumns from "./hooks/useContractorsTableColumns";

export default function ContractorsView({ publisher }) {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const [contractors, loading, error] = useCollectionData(
		db.collection("contractors").where("publisher.id", "==", publisher.id).where("deleted", "==", false),
	);

	const columns = useContractorsTableColumns();
	const getDropdownMenuOptions = useContractorsDropdownMenuOptions();

	return (
		<>
			<LoadingContext data={contractors} loading={loading} error={error}>
				<Table
					data={contractors}
					columns={columns}
					getDropdownMenuOptions={getDropdownMenuOptions}
					onClick={({ id }) => navigate(id)}
				/>
			</LoadingContext>

			<OpenButton primary text={t("addContractor", "Add contractor")}>
				{({ setOpen }) => <AddContractorForm publisher={publisher} onClose={() => setOpen(false)} />}
			</OpenButton>
		</>
	);
}
